exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head-box[data-v-221405bc] {\n  overflow: hidden;\n}", ""]);

// exports
